import { HTMLAttributes } from "react";
import { cn } from "@/lib/cn";

export function Skeleton({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      role="status"
      aria-label="Ładowanie"
      className={cn("animate-pulse bg-bg-subtle rounded", className)}
      {...rest}
    />
  );
}
